import { render, staticRenderFns } from "./CaliforniaVoluntaryCarbonMarketDisclosure.vue?vue&type=template&id=3f1074fa&"
import script from "./CaliforniaVoluntaryCarbonMarketDisclosure.vue?vue&type=script&lang=js&"
export * from "./CaliforniaVoluntaryCarbonMarketDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports